// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  ${(props) => `
  background: ${props.theme.colors.PRIMARY.PALEGRAY};
  padding: 0px;
  margin-bottom: 3px;
  padding-top:${props.isConfirmationPage ? props.theme.spacing.ELEM_SPACING.MED : 0};`}

  @media ${(props) => props.theme.mediaQuery.smallMax} {
    .bag-items {
      ${(props) => `
    margin-left: ${props.theme.spacing.ELEM_SPACING.XS_7};
    margin-right: ${props.theme.spacing.ELEM_SPACING.XS_7};
    width: calc(100% - ${props.theme.spacing.ELEM_SPACING.XS_7}*2);`}
    }
  }
  .right-sec {
    margin-bottom: ${(props) => (props.marginTop ? props.theme.spacing.LAYOUT_SPACING.MED : 0)};
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: ${(props) => (props.marginTop ? '78px' : 0)};
      margin-bottom: 0;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin-top: ${(props) => (props.marginTop ? props.theme.spacing.LAYOUT_SPACING.XS : 0)};
      margin-bottom: 0;
      width: 35.1%;
    }
  }

  .hide-mobile {
    display: none;
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: block;
    }
  }

  .placeholder-right div {
    background: ${(props) => props.theme.colorPalette.white};
    padding: 10px 0;
    margin-bottom: 5px;
    text-align: center;
  }

  .checkout-page-error {
    padding-bottom: 0px;
    span {
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      font-weight: ${(props) => props.theme.typography.fontWeights.extrabold};
    }
  }

  .recommendationsWrapper {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
  }
  .new-sfl-section {
    margin-bottom: 15px;
    padding: 16px;
  }
`;

export default styles;
